import { render, staticRenderFns } from "./BulkUpdate.vue?vue&type=template&id=62d87cbf&scoped=true"
import script from "./BulkUpdate.vue?vue&type=script&lang=js"
export * from "./BulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./BulkUpdate.vue?vue&type=style&index=0&id=62d87cbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d87cbf",
  null
  
)

export default component.exports